const getUsername = function(firstName, lastName)
{
	var nameReturn = firstName + " " + lastName;
	if ( !firstName || firstName == "" ) { nameReturn = "Unassigned"; }
	
	return nameReturn;
}

export { getUsername };